module.exports = __webpack_public_path__ + "static/media/shout.fe839f11.svg";